import {
  React,
  Component,
} from 'imports/CommonImports';

import {IconWithTooltip} from 'imports/DesignImports';

import {
  TooltipIcon,
} from 'imports/IconsImports';

import {
  Paper,
  Divider,
} from 'material-ui';

const styles = {
  column: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    flex: '1',
  },
  formContainer: {
    backgroundColor: '#FBFBFB',
    marginTop: '0.5em',
  },
  contentContainer: {
    padding: '1em'
  },
  section: {
    padding: '1em'
  },
  formData: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  tooltipIcon: {
    color: '#212F55',
    marginLeft: '0.1em'
  },
  labelTooltipContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  labelSection: {
    flex: '1',
    padding: '1em',
    display: 'flex',
    justifyContent: 'space-around'
  },
  fourSection: {
    flex: '5',
    padding: '1em',
  },
  label: {
    textAlign: 'right',
    fontSize: '0.8em',
    color: '#212F55',
    fontFamily: 'Lato'
  },
  textAreaLabel: {
    textAlign: 'right',
    flex: '1',
    marginTop: '1.5em',
    fontSize: '0.8em',
    color: '#212F55',
    fontFamily: 'Lato'
  },
  divider: {
    marginRight: '5em'
  },
  textAreaContainer:{
    flex: '1'
  },
  textArea: {
    borderRight: '1px solid #E0E0E0',
    borderLeft: '1px solid #E0E0E0',
    borderTop: '1px solid #E0E0E0',
    color: '#212F55',
    fontFamily: 'Lato'
  },
  textField: {
    color: '#212F55',
    fontFamily: 'Lato',
    marginTop: '0.1em'
  },
  selectField: {
    color: '#212F55',
    fontFamily: 'Lato'
  },
  selectedMenuItem:{
    color: '#EC2024'
  }
}

class PostulationForm extends Component {
  state = {
    economicImpact: 1,
    solutionType: [],
    benefitType: [],
    novelty: "Nuevo para la empresa",
    implementationDate: null,
    name: '',
    leaderFirstName: '',
    leaderLastName: '',
    leaderEmail: '',
    problem: '',
    solution: '',
    benefits: '',
    sponsor: '',
    area: ''
  }
  render() {
    return (
      <Paper zDepth={1} style={{...styles.column, ...styles.formContainer}}>
        <div style={{...styles.row, ...styles.contentContainer}}>
          <div style={styles.row}>
            <div style={{...styles.column, ...styles.labelSection}}>
              <div style={styles.label}>Nombre del proyecto</div>
              <div style={styles.label}>Nombre líder</div>
              <div style={styles.label}>Apellidos líder</div>
              <div style={styles.label}>Mail líder</div>
            </div>
            <div style={{...styles.column, ...styles.section}}>
              <div style={styles.textFieldContainer}>
                {this.props.project.information.name}
              </div>
              <div style={styles.textFieldContainer}>
                {this.props.project.information.leader_name}
              </div>
              <div style={styles.textFieldContainer}>
                {this.props.project.information.leader_email}
              </div>
            </div>
          </div>
          <div style={styles.row}>
            <div style={{...styles.column, ...styles.labelSection}}>
              <div style={styles.label}>Sponsor</div>
              <div style={styles.label}>Área</div>
              <div style={styles.label}>Año de implementación <IconWithTooltip icon={<TooltipIcon style={styles.tooltipIcon}/>} tooltip="En qué año y mes se comenzó o comenzará a ejecutar el proyecto"/></div>
              <div style={styles.label}>Impacto económico ({this.props.data ? this.props.data.company.currency : this.props.company_currency})<IconWithTooltip icon={<TooltipIcon style={styles.tooltipIcon}/>} tooltip="Escribe un valor aproximado a modo de referencia"/></div>
            </div>
            <div style={{...styles.column, ...styles.section}}>
              <div>
                {this.props.project.sponsor_name}
              </div>
              <div>
                {this.props.project.area.name}
              </div>
              <div>
                {this.props.project.information.start_date}
              </div>
              <div>
                {this.props.project.information.economic_impact}
              </div>
            </div>
          </div>
        </div>
        <Divider inset={true} style={styles.divider}/>
        <div style={{...styles.row, ...styles.contentContainer}}>
            <div style={{...styles.column, ...styles.labelSection}}>
              <div style={styles.textAreaLabel}>Problema<br/><br/><i>Describa la necesidad problema u oportunidad que da origen al proyecto.</i></div>
              <div style={styles.textAreaLabel}>Solución<br/><br/><i>Explique en que consiste la solución: objetivos, principales características y atributos.</i></div>
              <div style={styles.textAreaLabel}>Beneficios <br/><br/><i>Describa todos los beneficios que genera el proyecto: económico, sociales, ambientales, entre otros.</i></div>
            </div>
            <div style={{...styles.column, ...styles.fourSection}}>
              <div>
                {this.props.project.problem}
              </div>
              <div>
                {this.props.project.solution}
              </div>
              <div>
                {this.props.project.benefits}
              </div>
            </div>
        </div>
        <Divider inset={true} style={styles.divider}/>
        <div style={{...styles.row, ...styles.contentContainer}}>

        </div>
      </Paper>
    );
  }

  handleSelectChange = (event, index, values, type) => {
    this.props.handleSelectChange(event, index, values, type);
    this.setState({[type]: values})
  }

  handleDateChange = (event, date) => {
    this.props.handleDateChange(event, date)
    this.setState({implementationDate: date})
  }

  handleTextChange = (event, type) => {
    this.props.handleTextChange(event, type)
    this.setState({[type]: event.target.value})
  }
}

export default PostulationForm;



// WEBPACK FOOTER //
// ./src/components/postulation/ProjectPostulationShow.js